"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ServiceType = _interopRequireDefault(require("./components/ServiceType"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ServiceTypes = function ServiceTypes(_ref) {
  var iconColor = _ref.iconColor,
    _ref$serviceTypes = _ref.serviceTypes,
    serviceTypes = _ref$serviceTypes === void 0 ? [] : _ref$serviceTypes;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "ui-service-types list-unstyled"
  }, serviceTypes.map(function (st) {
    return /*#__PURE__*/_react["default"].createElement(_ServiceType["default"], {
      iconColor: iconColor,
      key: "service-type-".concat(st.code),
      level: 0,
      serviceType: st,
      showIcon: true
    });
  }));
};
ServiceTypes.propTypes = {
  /** color of ServiceType icons */
  iconColor: _propTypes["default"].string.isRequired,
  /** array of serviceType objects */
  serviceTypes: _propTypes["default"].array.isRequired
};
ServiceTypes.defaultProps = {
  iconColor: '#712F79' // $eggplant-color
};
var _default = exports["default"] = ServiceTypes;